import React from 'react'
import './Newsletter.css'

const Newsletter = () => {
    return (
      <div className="newsCont">
        <div className="newsHead">Newsletter</div>

        <div className="newsSubHead">Subcribe to our monthly Newsletter.</div>

        <div className="newsEmailCont">
          <div className="newsEmail">
            <svg
              width="30"
              height="26"
              viewBox="0 0 24 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M23.873 2.3873C23.873 1.07429 22.7987 0 21.4857 0H2.3873C1.07429 0 0 1.07429 0 2.3873V16.7111C0 18.0241 1.07429 19.0984 2.3873 19.0984H21.4857C22.7987 19.0984 23.873 18.0241 23.873 16.7111V2.3873ZM21.4857 2.3873L11.9365 8.35556L2.3873 2.3873H21.4857ZM21.4857 16.7111H2.3873V4.7746L11.9365 10.7429L21.4857 4.7746V16.7111Z"
                fill="#016B37"
              />
            </svg>

            <span className="newsVl"> </span>

            <input
              type="email"
              className="newsEmailInput"
              placeholder="someone@example.com"
            />
          </div>

          <button className="newsSubmit">Submit</button>
        </div>
      </div>
    );
}

export default Newsletter
